import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        NgbModule,
        InfiniteScrollModule
    ],
    exports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, NgbModule, InfiniteScrollModule]
})
export class FdeGatewaySharedLibsModule {
    static forRoot(): ModuleWithProviders<FdeGatewaySharedLibsModule> {
        return {
            ngModule: FdeGatewaySharedLibsModule
        };
    }
}
